module.exports = __webpack_public_path__ + "img/5.8c74cd6f.png";